/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProductsByIdsDto } from '../../models/get-products-by-ids-dto';
import { PaginatedDtoOfProductListItemDto } from '../../models/paginated-dto-of-product-list-item-dto';

export interface FindProductsByIds$Params {
      body: GetProductsByIdsDto
}

export function findProductsByIds(http: HttpClient, rootUrl: string, params: FindProductsByIds$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfProductListItemDto>> {
  const rb = new RequestBuilder(rootUrl, findProductsByIds.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfProductListItemDto>;
    })
  );
}

findProductsByIds.PATH = '/api/v1/products/by-ids';
